import React, { Component } from 'react'
import { Link } from 'react-router';
import { validatable } from 'components/utils';
import { Dialog } from "@blueprintjs/core";
import TextTruncate from 'react-text-truncate';
import { TextArea } from 'components/tt-forms/common';
import { Text } from 'components/tt-forms/common';
import moment from 'moment';
import { get, isEmpty } from 'lodash';

class RowItemXuLyThanhTraTrung extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      noiDung: '',
      openDoiTuong: false,
      isHoanThanh: false,
      yKienXuLy: []
    }
  }

  componentDidMount() {
    if (this.props.yKienXuLy) {
      let state = this.state;
      const yKienXuLy = this.props.yKienXuLy.find(item => item.doiTuongId === this.props.item.doiTuongThanhTraTrung.doiTuongThanhTraId) || {};
      state.noiDung = yKienXuLy.noiDung;
      state.isHoanThanh = yKienXuLy.dahoanThanh;
      this.setState({
        yKienXuLy: this.props.yKienXuLy
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.yKienXuLy) {
      let state = this.state;
      const yKienXuLy = nextProps.yKienXuLy.find(item => item.doiTuongId === nextProps.item.doiTuongThanhTraTrung.doiTuongThanhTraId) || {};
      state.noiDung = yKienXuLy.noiDung;
      state.isHoanThanh = yKienXuLy.dahoanThanh;
      this.setState({
        yKienXuLy: nextProps.yKienXuLy,
      });
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formDeXuat'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  onChange(count, doiTuongThanhTraId, e) {
    const yKienXuLy = [...this.state.yKienXuLy];
    const newYKien = yKienXuLy.map(item => {
      if (item.doiTuongId === doiTuongThanhTraId) {
        item.noiDung = e.target.value;
      }
      return item;
    });
    this.setState({
      yKienXuLy: newYKien
    });
  }

  closeDialog(name, doiTuongThanhTraId) {
    let newYKienXuLy = [...this.state.yKienXuLy].map(item => {
      if (item.doiTuongId === doiTuongThanhTraId) {
        item.noiDung = this.state.noiDung;
      }
      return item;
    });
    this.setState({
      yKienXuLy: newYKienXuLy,
      isOpen: false,
      openDoiTuong: false
    });
  }

  handleView() {
    this.setState({
      isOpen: true
    });
  }

  onOpenDialog() {
    this.setState({
      openDoiTuong: true
    });
  }

  async handleSubmit(type, doiTuongId) {
    if (type === 'hoanthanh') {
      if (this.validateSubmitForm()) {
        if (this.state.yKienXuLy) {
          let newYKienXuLy = [...this.state.yKienXuLy].map(item => {
            if (item.doiTuongId === doiTuongId) {
              item.dahoanThanh = true;
            }
            return item;
          });
          await this.setState({
            yKienXuLy: newYKienXuLy,
            isHoanThanh: true
          });
        }
        this.props.onChange(this.state.yKienXuLy);
        this.closeDialog();
      }
    }
    if (type === 'luu') {
      this.props.onChange(this.state.yKienXuLy);
      this.closeDialog();
    }
  }

  render() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const { count } = this.props;
    const { cuocThanhTras, doiTuongThanhTraTrung, namThanhTra, loaiCuoc } = this.props.item;
    const LisData = cuocThanhTras.map((item, index) => {
      if (index === 0) {
        return (
          <tr key={index}>
            <td rowSpan={cuocThanhTras.length}>{count}</td>
            <td rowSpan={cuocThanhTras.length} className='txt-underline'>
              <Link className='txt-underline txt-regular' onClick={this.onOpenDialog.bind(this)}>{doiTuongThanhTraTrung.ten || ''}</Link>
              <Dialog
                isOpen={this.state.openDoiTuong}
                onClose={this.closeDialog.bind(this)}
                title='Thông tin đối tượng thanh tra, kiểm tra'
                className="dialog-default wrap-block">
                <div className='row pl30 pr30 pt20'>
                  <Text
                    className="col-50 mb10"
                    label="Tên đối tượng:"
                    value={doiTuongThanhTraTrung.ten || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Nhóm đối tượng:"
                    value={''} />
                  <Text
                    className="col-50 mb10"
                    label="Loại đối tượng:"
                    value={doiTuongThanhTraTrung.loaiDoiTuongThanhTraInfo && doiTuongThanhTraTrung.loaiDoiTuongThanhTraInfo.text ? doiTuongThanhTraTrung.loaiDoiTuongThanhTraInfo.text : ''} />
                  <Text
                    className="col-50 mb10"
                    label="Ngành/Lĩnh vực:"
                    value={doiTuongThanhTraTrung.linhVucDoiTuongThanhTraInfo && doiTuongThanhTraTrung.linhVucDoiTuongThanhTraInfo.ten ? doiTuongThanhTraTrung.linhVucDoiTuongThanhTraInfo.ten : ''} />
                  <Text
                    className="col-50 mb10"
                    label="Huyện/TP:"
                    value={get(doiTuongThanhTraTrung, 'quanHuyenInfo.name')} />
                  <Text
                    className="col-50 mb10"
                    label="Phường/Xã:"
                    value={get(doiTuongThanhTraTrung, 'phuongXaInfo.name')} />
                  <Text
                    className="col-50 mb10"
                    label="Địa chỉ:"
                    value={doiTuongThanhTraTrung.diaChi || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Số điện thoại:"
                    value={doiTuongThanhTraTrung.soDienThoai || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Ghi chú:"
                    value={doiTuongThanhTraTrung.ghiChu || ''} />
                </div>
              </Dialog>
            </td>
            <td>{get(item, 'donViInfo.ten') || ''}</td>
            <td className='txt-center'>{get(item, 'quyetDinhPheDuyetKTTT') || ''}</td>
            <td rowSpan={cuocThanhTras.length}>{namThanhTra || ''}</td>
            <td>
              <Link className='txt-underline text-color-default' to={`/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/${get(item, 'idCuocThanhTra')}`}>
                {
                  !isEmpty(item.tenCuocThanhTra) &&
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={get(item, 'tenCuocThanhTra')} />
                }
              </Link>
              <div className='mt10'>{get(item, 'soDoiTuong')} đối tượng</div>
            </td>
            <td rowSpan={cuocThanhTras.length}>
              <div className="mgbt10">Đề xuất chuyên viên xử lý: </div>
              {
                this.state.noiDung ?
                  <Link className="txt-underline" onClick={this.handleView.bind(this)}>
                    <TextTruncate
                      line={3}
                      truncateText="…"
                      text={this.state.noiDung} />
                  </Link> :
                  <Link className="txt-underline" onClick={this.handleView.bind(this)}>
                    Nhập
                  </Link>
              }
              <Dialog
                isOpen={this.state.isOpen}
                onClose={this.closeDialog.bind(this, 'isClose', count, doiTuongThanhTraTrung.doiTuongThanhTraId)}
                title='Đề Xuất Xử Lý'
                className="dialog-default wrap-block">
                <div className='row pl30 pr30 pt20'>
                  <Text
                    className="col-50 mb10"
                    label="Thời gian phản hồi"
                    value={moment().format('DD/MM/YYYY')} />
                  <Text
                    className="col-50 mb10"
                    label="Chuyên viên phản hồi:"
                    value={userInfo.name} />
                  <TextArea bindValidator={this} require channel="formDeXuat" className="col-100 mb5" label="Nội dung đề xuất:" value={this.state.noiDung} onChange={this.onChange.bind(this, count, doiTuongThanhTraTrung.doiTuongThanhTraId)} name='yKienDeXuat' maxLength={2000} />
                </div>
                <div className='mt10'>
                  <div className='big-border'></div>
                </div>
                <div className="action-form-wrap pt20">
                  <div className="box-bottom">
                    <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this, 'close', doiTuongThanhTraTrung.doiTuongThanhTraId)}><span>Đóng</span></Link>
                    {/* <Link className="btn-action btn-save action-todo" onClick={this.handleSubmit.bind(this, 'luu')}><span>Lưu</span></Link> */}
                    <Link className='btn-action btn-complete position-default' role="button" onClick={this.handleSubmit.bind(this, 'hoanthanh', doiTuongThanhTraTrung.doiTuongThanhTraId)}><span>Hoàn thành</span></Link>
                  </div>
                </div>
              </Dialog>
            </td>
            <td>{get(item, 'loaiCuoc.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'}</td>
            <td>{get(item, 'kyThanhTra') || ''}</td>
            <td>{get(item, 'trangThaiXuLyTrungTaiDonViInfo.text', '')}</td>
            <td rowSpan={cuocThanhTras.length}>{this.state.isHoanThanh ? 'Đã hoàn thành' : 'Đang xử lý'}</td>
          </tr>
        )
      }
      return (
        <tr key={index}>
          <td className='bg-white txt-left'>{get(item, 'donViInfo.ten') || ''}</td>
          <td className='bg-white txt-center'>{get(item, 'quyetDinhPheDuyetKTTT') || ''}</td>
          <td className='bg-white'>
            <Link className='txt-underline text-color-default' to={`/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/${get(item, 'idCuocThanhTra')}`}>
              {
                !isEmpty(item.tenCuocThanhTra) &&
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={get(item, 'tenCuocThanhTra')} />
              }
            </Link>
            <div className='mt10'>{get(item, 'soDoiTuong')} đối tượng</div>
          </td>
          <td>{get(item, 'loaiCuoc.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'}</td>
          <td className='bg-white'>{get(item, 'kyThanhTra') || ''} </td>
          <td className='bg-white'>{get(item, 'trangThaiXuLyTrungTaiDonViInfo.text', '')}</td>
        </tr>
      )
    })
    return (
      <tbody className="table-body">
        {LisData}
      </tbody>
    )
  }
}

export default (validatable(RowItemXuLyThanhTraTrung));


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/RowItemXuLyThanhTraTrung.jsx